import React from "react";
import {useTranslation} from "react-i18next";
import { Link } from "react-router-dom";
import linkedinSVG from '../../../assets/images/svgs/linkedin_black.svg';
import instagramSVG from '../../../assets/images/svgs/instagram_black.svg';
import youtubeSVG from '../../../assets/images/svgs/youtube_black.svg';
import telegramSVG from '../../../assets/images/svgs/telegram_black.svg';
import logoSVG from '../../../assets/images/logo-type-gray.svg';
import { paths } from "../../../app/routes/paths";
import { useRolePath } from "../../../app/routes/useRolePath";
import { NETWORK_IDS, type NetworkId } from "../../configuration/application/types";
import { usePublicConfiguration } from "../../configuration";

const NETWORK_ICONS: Record<NetworkId, string> = {
    instagram: instagramSVG,
    linkedin: linkedinSVG,
    youtube: youtubeSVG,
    telegram: telegramSVG,
};

const Footer = () => {
    const {t} = useTranslation();
    const toRolePath = useRolePath();
    const { configuration } = usePublicConfiguration();

    return (
        <footer className='container-fluid'>
            <div className="container">
                <div className="left-wrapper">
                    <div className="logo-block">
                        <img src={logoSVG} alt="Way to Mentors" />
                    </div>
                    <div className="terms-block">
                        <span>©2026 Way to mentors. All rights reserved.</span>
                        {configuration.isPublicOffer ? (
                            <Link className="link" to={toRolePath(paths.publicOffer)}>
                                {t('footer.public_offer')}
                            </Link>
                        ) : null}
                    </div>
                </div>
                <div className="right-wrapper">
                    <nav aria-label={t('footer.platform')}>
                        <ul className="about-block">
                            <li>
                                <Link className="link" to={toRolePath(paths.aboutUs)}>
                                    {t('footer.about_us')}
                                </Link>
                            </li>
                            <li>
                                <Link className="link" to={toRolePath(paths.changelog)}>
                                    {t('footer.platform_updates')}
                                </Link>
                            </li>
                            <li>
                                <Link className="link" to={`${toRolePath(paths.aboutUs)}#contacts`}>
                                    {t('footer.contact')}
                                </Link>
                            </li>
                        </ul>
                    </nav>
                    <div className="social-block">
                        {NETWORK_IDS.map((id) => {
                            const href = configuration.network[id];
                            if (!href) {
                                return null;
                            }
                            return (
                                <a
                                    key={id}
                                    className="socila-icon"
                                    href={href}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <img src={NETWORK_ICONS[id]} alt={id} />
                                </a>
                            );
                        })}
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
